"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const InitialLoaderShelf_1 = require("./InitialLoaderShelf");
const LoaderShelf_1 = require("./LoaderShelf");
/**
 * @deprecated use FetchModelShelf instead
 */
class ModelShelf {
    constructor(id, getModel, fetchOptions) {
        this.fetchModel = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this._loader.start();
                const resultModel = yield this._getModel(this._id);
                this.setModel(resultModel);
                if (this._onModelFetch) {
                    this._onModelFetch(this._model);
                }
            }
            catch (e) {
                if (this._onModelFetchError) {
                    this._onModelFetchError(e);
                }
            }
            finally {
                this._initialLoader.done();
                this._loader.end();
                if (this._onFinishFetch) {
                    this._onFinishFetch();
                }
            }
        });
        this.setModel = (model) => {
            this._model = model;
        };
        this._id = id;
        this._getModel = getModel;
        this._loader = new LoaderShelf_1.default();
        this._initialLoader = new InitialLoaderShelf_1.default();
        if (fetchOptions) {
            this._onModelFetch = fetchOptions.onModelFetch;
            this._onModelFetchError = fetchOptions.onModelFetchError;
            this._onFinishFetch = fetchOptions.onFinishFetch;
        }
        mobx_1.makeAutoObservable(this);
        this.fetchModel();
    }
    get initialLoader() {
        return this._initialLoader;
    }
    get loader() {
        return this._loader;
    }
    get model() {
        return this._model;
    }
}
exports.default = ModelShelf;
